import { v4 as uuidv4 } from "uuid";
export class ProjectTaskViewModel {
    constructor() {
        this.id = uuidv4();
        this.fullName = "";
        this.profileImageUrl = "";
        this.mediaFileId = "";
        this.code = 0;
        this.name = "";
        this.createdOnAsString = "";
        this.description = "";
        this.totalTimeInSeconds = 0;
        this.timeDifferencesFormatted = "";
    }
}
export default class ProjectTaskView extends ProjectTaskViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
